<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <vx-card v-else>
      <div>
        <div
          slot="no-body"
          class="tabs-container pt-6 inventory_tabSec"
          id="view-customer-tab"
        >
          <vs-table
            @selected="handleSelected"
            :max-items="descriptionItems[0]"
            pagination
            :data="serviceList"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div
                style="margin-right: auto; font-size: 1.5rem; font-weight: 550"
              >
                {{ $t("setup.label.Services") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  @click="$router.push({ name: 'Create Service' })"
                  size="small"
                  >{{ $t("setup.label.CreateService") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.ServiceCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.ServiceDescription") }}</vs-th>
              <vs-th>{{ $t("setup.label.ServiceType") }}</vs-th>
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th>{{ $t("setup.label.Isoptional") }}</vs-th>
              <vs-th>{{ $t("setup.label.Isautoprovision") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="service"
                v-for="(service, index) in data"
              >
                <vs-td :data="service.serviceCode">{{
                  service.serviceCode
                }}</vs-td>
                <vs-td :data="service.serviceDescription">{{
                  service.serviceDescription
                }}</vs-td>
                <vs-td :data="service.serviceAddress">{{
                  service.serviceType
                }}</vs-td>
                <vs-td :data="service.serviceAddress">{{
                  service.serviceStatus
                }}</vs-td>
                <vs-td :data="service.isOptional">{{
                  service.isOptional
                }}</vs-td>
                <vs-td :data="service.isAutoProvision">{{
                  service.isAutoProvision
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(service)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editService(service.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      class="icon_row"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        delServiceId = service.id;
                        deleteservicemastersPopup = true;
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <delete-popup
        :deletePopup="deleteservicemastersPopup"
        :title="$t('setup.label.Service')"
        @deletePressed="deleteservicemasters()"
        @cancelPressed="deleteservicemastersPopup = false"
      >
      </delete-popup>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTable: "",
      toggleTeam: true,
      pages1: [
        { name: "Services", active: "active" },
        { name: "Products", active: "inactive" },
      ],
      descriptionItems: [5, 10, 15],
      deleteservicemastersPopup: false,
      delServiceId: "",
      delProId: "",
      deleteproductPopup: false,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      serviceList: (state) => state.serviceProducts.servicelist,
      productlist: (state) => state.serviceProducts.productlist,
    }),
  },
  methods: {
    handleSelected(service) {
      this.$router.push({ name: "View Services", params: { id: service.id } });
    },

    async deleteservicemasters() {
      this.deleteservicemastersPopup = false;
      await this.$store.dispatch(
        "serviceProducts/deleteservicemastersAction",
        this.delServiceId
      );
      this.$toasted.success("Deleted Successfully");
      this.getserviceList();
    },

    async getserviceList() {
      try {
        await this.$store.dispatch("serviceProducts/setServiceList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },

    editService(id) {
      this.$router.push({ name: "Edit Service", params: { id: id } });
    },
  },
  mounted() {
    this.toggleTeam = true;
    this.getserviceList();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.con-vs-tabs .con-ul-tabs,
.vs-tabs--ul {
  position: absolute;
  left: 1rem;
  top: 1.2rem;
}
</style>
